import React, {useState} from 'react';
import { TreeTable } from 'primereact/treetable';
import {Column} from "primereact/column";
import {calculateStatus, useTaskTree, findTaskIdFromTaskTree, useResponsibleHiearchicalList, useCanEditTaskIds} from "../../hooks/taskHooks";
import {DateTime} from "luxon";
import {useListCompanyAccountsQuery} from "../../apis/companiesApi";
import {Checkbox} from "primereact/checkbox";
import {Button} from "primereact/button";
import TaskMenu from "components/menus/TaskMenu";
import {useNavigate} from "react-router-dom";
import {useUserProfileQuery} from "../../apis/authenticationApi";

/**
 *
 * @param {*} param0
 * @returns
 */
const TaskTable = ({loading, tasks, showCompleteDefaultStatus, editTaskEndpoint, newSubTaskEndpoint, newTaskEndpoint, showPrivacyColumn, hideShowCompletedFilter, hideDeadline, hideSubtaskStatus}) => {
    const {data: companyUsers} = useListCompanyAccountsQuery();
    const [showCompleted, setShowCompleted] = useState(showCompleteDefaultStatus);
    const recursiveTasks = useTaskTree(showCompleted, tasks);
    const recursiveTasksAnyState = useTaskTree(true, tasks);
    const {data: userProfile} = useUserProfileQuery();
    const hierarchyUsers = useResponsibleHiearchicalList(userProfile?.company?.account);
    const userCanEditTaskIds = useCanEditTaskIds();

    const navigate = useNavigate();

    const responsibleBodyTemplate = (rowData) => {
        if(!companyUsers) return "-";
        const user = companyUsers.find(user => user.id === rowData?.data?.responsible);

        return user ? (user?.registered ? `${user?.firstName} ${user?.lastName}` : user?.email) :
            "-";
    }

    const completedTasksBodyTemplate = (rowDataCurrentTask) => {
       const findTask = findTaskIdFromTaskTree(recursiveTasksAnyState, rowDataCurrentTask.key);
       const completedTasksCnt = (findTask?.children || []).filter(e => e.completed).length;
       return findTask?.children?.length ? `${completedTasksCnt}/${findTask?.children.length}` : "N/A"
    }

    const deadlineTemplate = (rowData) => {
        const deadline = rowData?.data?.deadline;
        return deadline? DateTime.fromMillis(deadline).toLocaleString() : "";
    }



    const taskMenu = (taskData) => {

        const fixedValueOrFunction = (endpoint) => {
            if(typeof endpoint === 'function') {
                return endpoint(taskData);
            } else {
                return endpoint;
            }
        }

        const inHiearchyOfUser = hierarchyUsers?.find(u => u?.id === taskData?.responsible);
        const editTaskEndpointDt = editTaskEndpoint? `${fixedValueOrFunction(editTaskEndpoint)}/${taskData?.id}` : undefined;
        const newSubTaskEndpointDt = (inHiearchyOfUser && newSubTaskEndpoint)? `${fixedValueOrFunction(newSubTaskEndpoint)}/${taskData?.id}` : undefined;
        const userCanAddSubTask = userProfile?.company?.role === "CompanyOwner" || inHiearchyOfUser;
        const userCanEditTask = userCanEditTaskIds.includes(taskData.id);
        const userCanSeeMenu = taskData.taskStatus !== 'Done' && (userCanAddSubTask || userCanEditTask);

        //I will use below the same conditions for edit and delete task, if edit is possible and enabled, delete will too
        return (
            <>
                {userCanSeeMenu && (<TaskMenu
                                        editTaskEndpoint={userCanEditTask? editTaskEndpointDt: undefined}
                                        deleteTask={userCanEditTask && editTaskEndpointDt? {type: taskData?.taskType, id: taskData.id}: undefined}
                                        newSubTaskEndpoint={userCanAddSubTask? newSubTaskEndpointDt : undefined} />)}
            </>
        );
    }


    const buildHeader = () => {
        const newTaskAction = newTaskEndpoint ? () => navigate(newTaskEndpoint): undefined;
        return (
            <div className="table-header">
                    {newTaskAction &&
                        <div className="header-section">
                            <div className="button-panel header-section">
                                    <Button type="button" label="New" icon="pi pi-plus" tooltip="Add Task" onClick={newTaskAction} />
                            </div>
                        </div>
                    }
                    {!hideShowCompletedFilter &&
                        <div className={newTaskAction? "header-section" : ""}>
                            <div className="show-completed-tasks" >
                                    <Checkbox inputId="show-completed" checked={showCompleted} onChange={e => setShowCompleted(e.checked)} />
                                    <label htmlFor="show-completed">Show Completed Tasks</label>
                            </div>
                        </div>
                    }
            </div>
        );
    };

    return (
        <div className="mobile-horizontal-scrollable">
            <TreeTable value={recursiveTasks}
                    header={buildHeader()}
                    loading={loading}
                    responsiveLayout="scroll"  emptyMessage="No Tasks"
                    className="task-table">
                    <Column field="name" header="Task" sortable expander/>
                    <Column field="responsible" header="Responsible" sortable body={responsibleBodyTemplate} />
                    {showPrivacyColumn && <Column field="privacy" sortable header="Sharable / Private" />}
                    <Column field="taskStatus" header="Status" sortable body={(rowData) => calculateStatus(rowData?.data)} />
                    {!hideSubtaskStatus && <Column field="completedSubTasks" header="Subtasks Status" sortable body={completedTasksBodyTemplate} />}
                    {!hideDeadline && <Column field="deadline" header="Deadline" style={{width: '10rem'}} sortable body={deadlineTemplate}/>}
                    {taskMenu && <Column className="action-column" bodyClassName="p-text-center" body={(dt) => taskMenu(dt?.data)} /> }
            </TreeTable>
        </div>
    )
}

export default TaskTable;
